import { getErrorMessage } from "@/core/services";
import { useAsyncList } from "@/ds";
import {
  getEstruturaBase,
  getTiposObraBase,
  getVersoesEscopoPadrao,
  listarMoedas,
} from "@/modules/financeiro-configuracoes";
import type {
  LinhaEstrutura,
  TipoObraBase,
  VersaoEscopoPadrao,
} from "@/modules/financeiro-configuracoes";
import { listObraEmbarcacoes } from "@/modules/obras";
import type { MoedaOpcao } from "@/modules/financeiro-obras";
import type { ObraEmbarcacaoOpcao } from "@/modules/obras";
import {
  ESCOPOS_PADRAO_ERROR_MESSAGE,
  ESCOPOS_PADRAO_FORBIDDEN_MESSAGE,
  ESCOPOS_PADRAO_VERSOES_ERROR_MESSAGE,
} from "../escopos-padrao.constants";

const SEM_PARAMETROS = {};
const ESTRUTURA_COMPLETA = { incluirInativos: true };

function lookup<T>(carregar: (signal: AbortSignal) => Promise<T[]>, enabled: boolean) {
  return {
    enabled,
    fetcher: async (_params: object, signal: AbortSignal) => {
      const items = await carregar(signal);
      return { items, total: items.length };
    },
    params: SEM_PARAMETROS,
    forbiddenMessage: ESCOPOS_PADRAO_FORBIDDEN_MESSAGE,
    errorMessage: ESCOPOS_PADRAO_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  };
}

export function useEscoposPadraoLookups({
  podeVer,
  comMoedas,
}: {
  podeVer: boolean;
  comMoedas: boolean;
}) {
  const versoes = useAsyncList<object, VersaoEscopoPadrao>({
    ...lookup((signal) => getVersoesEscopoPadrao({ signal }), podeVer),
    errorMessage: ESCOPOS_PADRAO_VERSOES_ERROR_MESSAGE,
  });
  const tiposObra = useAsyncList<object, TipoObraBase>(
    lookup((signal) => getTiposObraBase({ signal }), podeVer),
  );
  const estrutura = useAsyncList<{ incluirInativos: boolean }, LinhaEstrutura>({
    ...lookup((signal) => getEstruturaBase(ESTRUTURA_COMPLETA, { signal }), podeVer),
    params: ESTRUTURA_COMPLETA,
  });
  const embarcacoes = useAsyncList<object, ObraEmbarcacaoOpcao>(
    lookup((signal) => listObraEmbarcacoes({ signal }), podeVer),
  );

  const moedas = useAsyncList<object, MoedaOpcao>({
    ...lookup((signal) => listarMoedas({ signal }), podeVer && comMoedas),
  });

  return {
    versoes,
    tiposObra: tiposObra.items,
    estrutura: estrutura.items,
    embarcacoes: embarcacoes.items,
    moedas: moedas.items,
  };
}
